module.exports = __webpack_public_path__ + "static/topics_bg-15b8b0a432106a3aa3f2a7a5a352fd61.jpg";